import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { CheckCircle, AlertCircle, Package, TrendingUp, Database, AlertTriangle } from 'react-feather';
import DataTable from 'react-data-table-component';

const DryRunModal = ({ isOpen, toggle, dryRunData, onTransfer, transferring }) => {
  if (!dryRunData) return null;

  const { summary, batch_details, message } = dryRunData;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered style={{ maxWidth: '800px' }}>
      <ModalHeader 
        toggle={toggle}
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          border: 'none',
          padding: '20px 24px'
        }}
      >
        <div className="d-flex align-items-center gap-3">
          <div 
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '12px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Package size={28} color="white" />
          </div>
          <div>
            <h4 className="mb-0" style={{ fontWeight: 600,textAlign:"left" }}>Dry Run Results</h4>
            <small style={{ opacity: 0.9 }}>Preview before transferring images</small>
          </div>
        </div>
      </ModalHeader>
      
      <ModalBody style={{ padding: '24px', backgroundColor: '#f8f9fc' }}>
        {/* Summary Section */}
        <div className="mb-4">
          <div className="d-flex align-items-center gap-2 mb-3">
            <TrendingUp size={20} color="#667eea" />
            <h5 className="mb-0" style={{ color: '#2d3748', fontWeight: 600 }}>
              Summary Overview
            </h5>
          </div>
          
          <div className="row g-3">
            {/* Total Images Card */}
            <div className="col-md-6">
              <div 
                className="p-4 rounded-3 h-100"
                style={{ 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
                  color: 'white'
                }}
              >
                <div className="d-flex align-items-center gap-2 mb-2">
                  <Database size={20} />
                  <small style={{ opacity: 0.9, fontWeight: 500 }}>Total Images to Process</small>
                </div>
                <h2 className="mb-0" style={{ fontWeight: 700, fontSize: '2.5rem' }}>
                  {summary.total_images_to_process}
                </h2>
              </div>
            </div>
            
            {/* Total Batches Card */}
            <div className="col-md-6">
              <div 
                className="p-4 rounded-3 h-100"
                style={{ 
                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                  boxShadow: '0 4px 15px rgba(245, 87, 108, 0.3)',
                  color: 'white'
                }}
              >
                <div className="d-flex align-items-center gap-2 mb-2">
                  <Package size={20} />
                  <small style={{ opacity: 0.9, fontWeight: 500 }}>Total Batches</small>
                </div>
                <h2 className="mb-0" style={{ fontWeight: 700, fontSize: '2.5rem' }}>
                  {summary.total_batches}
                </h2>
              </div>
            </div>
            
            {/* Stats Cards Row */}
            <div className="col-md-4">
              <div 
                className="p-3 rounded-3 h-100"
                style={{ 
                  backgroundColor: 'white',
                  border: '2px solid #d4edda',
                  boxShadow: '0 2px 8px rgba(40, 167, 69, 0.1)'
                }}
              >
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <small className="text-muted" style={{ fontWeight: 600 }}>New Images</small>
                  <CheckCircle size={18} color="#28a745" />
                </div>
                <h3 className="mb-0" style={{ color: '#28a745', fontWeight: 700 }}>
                  {summary.total_new_images}
                </h3>
                <div 
                  className="mt-2"
                  style={{
                    height: '4px',
                    backgroundColor: '#d4edda',
                    borderRadius: '2px',
                    overflow: 'hidden'
                  }}
                >
                  <div 
                    style={{
                      height: '100%',
                      width: `${(summary.total_new_images / summary.total_images_to_process) * 100}%`,
                      backgroundColor: '#28a745',
                      transition: 'width 0.3s ease'
                    }}
                  />
                </div>
              </div>
            </div>
            
            <div className="col-md-4">
              <div 
                className="p-3 rounded-3 h-100"
                style={{ 
                  backgroundColor: 'white',
                  border: '2px solid #fff3cd',
                  boxShadow: '0 2px 8px rgba(255, 193, 7, 0.1)'
                }}
              >
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <small className="text-muted" style={{ fontWeight: 600 }}>Existing Images</small>
                  <AlertCircle size={18} color="#ffc107" />
                </div>
                <h3 className="mb-0" style={{ color: '#ffc107', fontWeight: 700 }}>
                  {summary.total_existing_images}
                </h3>
                <div 
                  className="mt-2"
                  style={{
                    height: '4px',
                    backgroundColor: '#fff3cd',
                    borderRadius: '2px',
                    overflow: 'hidden'
                  }}
                >
                  <div 
                    style={{
                      height: '100%',
                      width: `${(summary.total_existing_images / summary.total_images_to_process) * 100}%`,
                      backgroundColor: '#ffc107',
                      transition: 'width 0.3s ease'
                    }}
                  />
                </div>
              </div>
            </div>
            
            <div className="col-md-4">
              <div 
                className="p-3 rounded-3 h-100"
                style={{ 
                  backgroundColor: 'white',
                  border: `2px solid ${summary.errors_count > 0 ? '#f8d7da' : '#e9ecef'}`,
                  boxShadow: `0 2px 8px ${summary.errors_count > 0 ? 'rgba(220, 53, 69, 0.1)' : 'rgba(0, 0, 0, 0.05)'}`
                }}
              >
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <small className="text-muted" style={{ fontWeight: 600 }}>Errors</small>
                  <AlertTriangle size={18} color={summary.errors_count > 0 ? '#dc3545' : '#6c757d'} />
                </div>
                <h3 className="mb-0" style={{ color: summary.errors_count > 0 ? '#dc3545' : '#6c757d', fontWeight: 700 }}>
                  {summary.errors_count}
                </h3>
                {summary.errors_count > 0 && (
                  <div 
                    className="mt-2"
                    style={{
                      height: '4px',
                      backgroundColor: '#f8d7da',
                      borderRadius: '2px',
                      overflow: 'hidden'
                    }}
                  >
                    <div 
                      style={{
                        height: '100%',
                        width: `${(summary.errors_count / summary.total_images_to_process) * 100}%`,
                        backgroundColor: '#dc3545',
                        transition: 'width 0.3s ease'
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Batch Details Section */}
        <div className="mb-3">
          <div className="d-flex align-items-center gap-2 mb-3">
            <Database size={20} color="#667eea" />
            <h5 className="mb-0" style={{ color: '#2d3748', fontWeight: 600 }}>
              Batch Details
            </h5>
          </div>
          
          <div 
            className="rounded-3 overflow-hidden"
            style={{ 
              backgroundColor: '#305bddff',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
            }}
          >
            <DataTable
              columns={[
                {
                  name: 'Batch ID',
                  selector: row => row.batch_id,
                  cell: row => (
                    <div className="d-flex align-items-center gap-2">
                      <Package size={16} color="#667eea" />
                      <span style={{ fontWeight: 600, color: '#2d3748' }}>Batch {row.batch_id}</span>
                    </div>
                  ),
                
                },
                {
                  name: 'New Images',
                  selector: row => row.new_images_count,
                  cell: row => (
                    <span 
                      className="badge"
                      style={{
                        backgroundColor: '#d4edda',
                        color: '#28a745',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        fontWeight: 600,
                        fontSize: '0.875rem'
                      }}
                    >
                      {row.new_images_count}
                    </span>
                  ),
        
                },
                {
                  name: 'Existing Images',
                  selector: row => row.existing_images_count,
                  cell: row => (
                    <span 
                      className="badge"
                      style={{
                        backgroundColor: '#fff3cd',
                        color: '#856404',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        fontWeight: 600,
                        fontSize: '0.875rem'
                      }}
                    >
                      {row.existing_images_count}
                    </span>
                  ),
            
                },
                {
                  name: 'Total Images',
                  selector: row => row.total_images_count,
                  cell: row => (
                    <span style={{ fontWeight: 700, color: '#2d3748' }}>
                      {row.total_images_count}
                    </span>
                  ),
                 
                },
              ]}
              data={batch_details}
              customStyles={{
                table: {
                  style: {
                    backgroundColor: '#f8f9fc',
                  },
                },
                headRow: {
                  style: {
                    backgroundColor: '#445abeff !important',
                    color: 'white',
                    fontWeight: 600,
                    fontSize: '14px',
                    border: 'none',
                  },
                },
                headCells: {
                  style: {
                    color: 'white',
                    fontWeight: 600,
                    padding: '14px 16px',
                  },
                },
                rows: {
                  style: {
                    backgroundColor: '#f8f9fc',
                    borderBottom: '1px solid #e9ecef',
                    '&:hover': {
                      backgroundColor: '#eef2ff',
                      cursor: 'pointer',
                    },
                  },
                },
                cells: {
                  style: {
                    padding: '14px 16px',
                  },
                },
              }}
              noDataComponent={
                <div style={{ padding: '20px', textAlign: 'center', color: '#6c757d' }}>
                  No batch details available
                </div>
              }
            />
          </div>
        </div>

        {/* Message Section */}
        <div 
          className="p-3 rounded-3 d-flex align-items-start gap-3"
          style={{ 
            background: 'linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)',
            border: '2px solid #bfdbfe',
            boxShadow: '0 2px 8px rgba(59, 130, 246, 0.1)'
          }}
        >
          <AlertCircle size={20} color="#3b82f6" style={{ marginTop: '2px', flexShrink: 0 }} />
          <div>
            <strong style={{ color: '#1e40af', display: 'block', marginBottom: '4px' }}>
              Status Message
            </strong>
            <span style={{ color: '#1e3a8a', fontSize: '0.95rem' }}>{message}</span>
          </div>
        </div>
      </ModalBody>
      
      <ModalFooter style={{ padding: '20px 24px', backgroundColor: 'white', borderTop: '1px solid #e9ecef' }}>
        <Button 
          color="light" 
          onClick={toggle} 
          disabled={transferring}
          style={{
            padding: '10px 24px',
            fontWeight: 600,
            borderRadius: '8px',
            border: '2px solid #e9ecef'
          }}
        >
          Cancel
        </Button>
        <Button 
          onClick={onTransfer}
          disabled={transferring || summary.total_new_images === 0}
          style={{
            padding: '10px 24px',
            fontWeight: 600,
            borderRadius: '8px',
            background: summary.total_new_images === 0 ? '#e9ecef' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            color: 'white',
            boxShadow: summary.total_new_images === 0 ? 'none' : '0 4px 12px rgba(102, 126, 234, 0.4)'
          }}
        >
          {transferring ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Transferring...
            </>
          ) : (
            'Transfer Images'
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DryRunModal;
